import { render, staticRenderFns } from "./ModalContainer.vue?vue&type=template&id=a540a11a&scoped=true&"
import script from "./ModalContainer.vue?vue&type=script&lang=js&"
export * from "./ModalContainer.vue?vue&type=script&lang=js&"
import style0 from "./ModalContainer.vue?vue&type=style&index=0&id=a540a11a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a540a11a",
  null
  
)

export default component.exports